import _ from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  createCustomPropertyListItem,
  clearCustomPropertyListItemErrors,
  clearCustomPropertyListItemAction
} from "actions/properties/customPropertyListItemActions";

import AdminForm from "components/admin/AdminForm";

const CustomPropertyListItemCreate = ({
  propertyId,
  formId,
  params,
  setParams,
  closeModal
}) => {
  const { lastAction, listItemErrors } = useSelector(
    state => state.customPropertyListItems
  );
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearCustomPropertyListItemErrors());
      dispatch(clearCustomPropertyListItemAction());
    };
  }, [dispatch]);

  useEffect(() => {
    if (_.isEmpty(params)) {
      setParams({
        property_id: propertyId,
        value: ""
      });
    }
  }, [params, setParams, propertyId]);

  // watch for success
  useEffect(() => {
    if (lastAction === "create") {
      closeModal();
    }
  }, [lastAction, closeModal]);

  const handleSubmit = (e, createParams) => {
    e.preventDefault();

    dispatch(createCustomPropertyListItem(propertyId, createParams));
  };

  if (_.size(params)) {
    return (
      <form
        id={formId}
        onSubmit={e => handleSubmit(e, params)}
        className="form container"
        noValidate
      >
        {/* Forms TODO: */}
        <AdminForm
          params={params}
          setParams={setParams}
          errors={listItemErrors}
        />
      </form>
    );
  }

  return "";
};

export default CustomPropertyListItemCreate;
